import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icons/Icon';

// do not use uuidv4() library in this component to avoid unnecessary re-renders due to the random generation of keys
const Breadcrumbs = ({ className = 'pb-12', links, shouldIncludeDashboard = true }) => {
  return (
    <nav aria-label="breadcrumb">
      <ul className={`flex items-center ${className}`}>
        {shouldIncludeDashboard && (
          <li className="flex">
            <>
              <a className="text-lg font-normal underline py-2.5 px-2.5 hover:text-vamos-black" href="/">
                Dashboard
              </a>
              <Icon name="navigate_next" />
            </>
          </li>
        )}
        {links.map((link, index) => (
          <React.Fragment key={link.name || link.href}>
            {/* Render the link if it's not the last item */}
            <li className="flex" key={link.href || link.name}>
              {index < links.length - 1 ? (
                <a className="text-lg font-normal underline py-2.5 px-2.5 hover:text-vamos-black" href={link.href}>
                  {link.name}
                </a>
              ) : (
                <span className="text-lg font-normal py-2.5 px-2.5">{link.name}</span>
              )}
              {index < links.length - 1 && <Icon name="navigate_next" />}
            </li>
          </React.Fragment>
        ))}
      </ul>
    </nav>
  );
};
Breadcrumbs.propTypes = {
  className: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  shouldIncludeDashboard: PropTypes.bool,
};
export default Breadcrumbs;
